export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7109_11751)">
                <path
                    d="M28.125 11.25H7.875V25.875C7.875 28.3603 9.88972 30.375 12.375 30.375H23.625C26.1103 30.375 28.125 28.3603 28.125 25.875V11.25Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.375 25.875H14.625V20.25C14.625 18.386 16.136 16.875 18 16.875C19.864 16.875 21.375 18.386 21.375 20.25V25.875Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="18" cy="21.375" r="1.125" fill="#3EAE60" />
                <path d="M21.375 23.625H28.125" stroke="#3EAE60" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.875 23.625H14.625" stroke="#3EAE60" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M28.125 11.25H7.875C7.875 9.38604 9.38604 7.875 11.25 7.875H24.75C26.614 7.875 28.125 9.38604 28.125 11.25Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.375 7.875H14.625C14.625 6.63236 15.6324 5.625 16.875 5.625H19.125C20.3676 5.625 21.375 6.63236 21.375 7.875Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.125 20.25L28.125 13.5C29.3676 13.5 30.375 14.5074 30.375 15.75L30.375 18C30.375 19.2426 29.3676 20.25 28.125 20.25Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.875 20.25L7.875 13.5C6.63236 13.5 5.625 14.5074 5.625 15.75L5.625 18C5.625 19.2426 6.63236 20.25 7.875 20.25Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_7109_11751">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
